export const pageContainer = {
  display: "flex",
  flexDirection: "column",
  px: { xs: 1, sm: 2 },
  maxWidth: "100%",
};

export const pageHeaderContainer = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  alignItems: { xs: "stretch", sm: "center" },
  justifyContent: "space-between",
  gap: { xs: 1, sm: 2 },
  width: "100%",
  mb: 2,
};

export const frequentListsContainer = {
  width: "100%",
  mb: 3,
};

export const listsTabsContainer = {
  borderBottom: 1,
  borderColor: "divider",
  mb: 2,
};

export const listInfoCard = {
  mb: 3,
};

export const listInfoContent = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

export const listInfoActions = {
  display: "flex",
  justifyContent: "flex-start",
  px: 2,
  pb: 1,
};

export const listDatesInfo = {
  mt: 1,
};

export const addItemForm = {
  mb: 4,
};

export const addItemFormGrid = {
  alignItems: "flex-end",
};

export const itemList = {
  width: "100%",
  p: 0,
  overflowX: "hidden",
};

export const itemWrapper = {
  width: "100%",
};

export const itemHeaderContainer = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  mb: 1,
};

export const listOptionsButton = {
  ml: 1,
};

export const menuItemIcon = {
  minWidth: "35px",
};

export const itemButton = (theme, colorKey) => ({
  color: theme.palette[colorKey].main,
  p: { xs: 1, sm: 1.5 },
});

export const notesDialogContent = {
  pt: 2,
};
